import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from 'src/shared/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/shared/components/ui/select'

export const FormSelect = ({
  name,
  label,
  description,
  methods,
  options,
  placeholder,
  disabled = false,
  className = '',
  classNameSelectTrigger = '',
  tiny = false,
}: {
  name: string
  label?: string | React.ReactNode
  description?: string
  methods: UseFormReturn<any>
  options: { value: string; label: React.ReactNode }[]
  placeholder?: string
  disabled?: boolean
  className?: string
  classNameSelectTrigger?: string
  tiny?: boolean
}) => {
  return (
    <FormField
      control={methods.control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <Select
            onValueChange={field.onChange}
            defaultValue={field.value}
            disabled={disabled}
            value={field.value}
            label={label}
          >
            <FormControl>
              <SelectTrigger
                size={tiny && !label ? 'tiny' : 'default'}
                className={classNameSelectTrigger}
                hasValue={Boolean(field.value)}
              >
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>

            <SelectContent>
              {options.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
